// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// TODO--this code is not called by anything other than analytics, but is likely to be updated in conjuction with
// code that calls planting service. Revisit after that and remove any dead code.

// Action Types
export const typePrefix = 'vra/planting/';
export const actions = [
  'SET_PLANTING_EVENTS'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer (
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_PLANTING_EVENTS:
      return {
        ...state,
        [action.payload['field-uuid']]: action.payload
      };

    default:
      return state;
  }
}

// Action Creators

export const setPlantingEvents = ( plantingEvents ) => {
  return {
    type: actions.SET_PLANTING_EVENTS,
    payload: plantingEvents
  };
};
